
import React from 'react';
import { Card } from '@/components/ui/card';
import { Profile } from '@/types/profile';
import { formatRelationshipType, formatIncomeRange } from '@/utils/dataFormatters';

interface ProfileBasicInfoSectionProps {
  profile: Profile;
}

export const ProfileBasicInfoSection: React.FC<ProfileBasicInfoSectionProps> = ({ profile }) => {
  return (
    <Card className="bg-white/5 border-white/10 p-4">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center">
          <span className="text-lg">📝</span>
        </div>
        <h3 className="text-white font-medium text-sm">Informações Básicas</h3>
      </div>
      <div className="grid grid-cols-2 gap-4 text-xs">
        {profile.occupation && (
          <div>
            <p className="text-white/60">Área de atuação</p>
            <p className="text-white">{profile.occupation}</p>
          </div>
        )}
        {profile.education && (
          <div>
            <p className="text-white/60">Educação</p>
            <p className="text-white">{profile.education}</p>
          </div>
        )}
        {profile.income && (
          <div>
            <p className="text-white/60">Renda</p>
            <p className="text-white">{formatIncomeRange(profile.income)}</p>
          </div>
        )}
        {(profile.city || profile.state_code || profile.country) && (
          <div>
            <p className="text-white/60">Localização</p>
            <p className="text-white">
              {[profile.city, profile.state_code, profile.country].filter(Boolean).join(', ')}
            </p>
          </div>
        )}
        {profile.sponsorship_value && (
          <div>
            <p className="text-white/60">Valor de Sponsorship</p>
            <p className="text-white">R$ {profile.sponsorship_value.toLocaleString()}</p>
          </div>
        )}
      </div>
    </Card>
  );
};
